import { apiClient } from "../axiosClient";

export interface SubscriptionRequest {
  email: string;
  type: "newsletter" | "waitlist";
}

export const subscribe = async (data: SubscriptionRequest) => {
  const response = await apiClient.post("/subscriptions", data);
  return response.data;
};
